import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ClientJS } from "clientjs";
import "./login.css";
import ToastMessage from "../ToastMessage/ToastMessage";
import {
  signIn,
  getCaptcha,
  captchaVerification,
  sendOtp,
  verifyOtp,
  ForgotPasswordUpdate,
} from "../../utils/request"; // Import Api Functions
import loginCodes from "../../utils/loginCodes";
import OTPInput from "react-otp-input";

const temp_res_data = {
  url: "http://localhost:3001",
  jwt: "dasdasdSADASWEREWFW$@#FDS%@#RDSFC@#R@",
};

const ChangePassword = () => {
  // const { t } = useTranslation();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [isPasswordVisible, setIsPasswordVisible] = useState(false); // State for toggling password visibility
  const [timerCount, setTimerCount] = useState(0);
  const [showResendOTP, setShowResendOTP] = useState(false);
  const [verifySpin, setVerifySpin] = useState(false);
  const [otp, setOtp] = useState("");

  // Extract callback URL from URL query parameters
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const callbackUrl = queryParams.get("callbackUrl") || temp_res_data.url;
  const clientId = queryParams.get("clientId");
  console.log("clientId", clientId);

  const navigate = useNavigate(); // Hook to navigate to another route

  const handleSubmit = async (event) => {
    event.preventDefault(); // Prevent default form submission

    // Reset states before each submit attempt
    setIsLoading(true);
    setError("");
    setSuccessMessage("");
    try {
      // If CAPTCHA is successful, proceed with sign-in API
      const forgotPasswordData = JSON.parse(
        sessionStorage.getItem("forgotPasswordData")
      );

      const clientId = JSON.parse(sessionStorage.getItem("clientId"));

      const { email } = forgotPasswordData;

      const passwordData = {
        email: email,
        newPassword: password,
        otp: otp,
      };

      console.log("Sending sign-in request:", passwordData); // Debug sign-in data

      const forgetPasswordResponse = await ForgotPasswordUpdate(passwordData);
      console.log("Sign-in response:", forgetPasswordResponse); // Debug API response

      // Handle different sign-in response cases
      if (forgetPasswordResponse?.code === 20) {
        startTimer(forgetPasswordResponse?.resendOtpTime);

        navigate(`/?clientId=${clientId}`);
      } else {
        console.error(
          "Login failed, unexpected response:",
          forgetPasswordResponse
        );
        setError("loginFailed");
      }
    } catch (err) {
      console.error("Login failed:", err);
      setError(err.message || "loginError");
    } finally {
      setIsLoading(false); // Reset loading state after the operation
    }
  };

  const startTimer = (timeCounter) => {
    setTimerCount(timeCounter); // Set timer to the initial value
  };

  useEffect(() => {
    if (timerCount === 0) {
      setShowResendOTP(false);
    }
  }, [timerCount]);

  useEffect(() => {
    const forgotPasswordData = JSON.parse(
      sessionStorage.getItem("forgotPasswordData")
    );
    if (forgotPasswordData && forgotPasswordData.resendOtpTime) {
      const { resendOtpTime } = forgotPasswordData;
      setTimerCount(resendOtpTime);
      setShowResendOTP(true);
    }
  }, []);

  useEffect(() => {
    if (timerCount === 0) return;

    const timerInterval = setInterval(() => {
      setTimerCount((prevState) => {
        if (prevState > 0) {
          return prevState - 1;
        }
        clearInterval(timerInterval); // Clear interval when timer reaches 0
        return 0;
      });
    }, 1000);

    return () => clearInterval(timerInterval); // Cleanup the interval on component unmount
  }, [timerCount]);

  // Handle OTP change
  const handleChange = (otpValue) => {
    setOtp(otpValue);
  };

  const handleResendOTP = async () => {
    console.log("Resend OTP");

    const forgotPasswordData = JSON.parse(
      sessionStorage.getItem("forgotPasswordData")
    );

    const { email } = forgotPasswordData;

    // If CAPTCHA is successful, proceed to sign in
    const userData = {
      email: email, // Assuming 'email' is declared somewhere in the scope
    };

    try {
      // Send OTP request
      const res = await sendOtp(userData); // Assuming sendOtp returns the response with a 'resendOtpTime' property

      if (res && res.resendOtpTime) {
        setShowResendOTP(true);
        startTimer(res.resendOtpTime);
      } else {
        console.error("Failed to receive resendOtpTime in response.");
      }
    } catch (error) {
      console.error("Error sending OTP:", error);
    }
  };
  const [passwordError, setPasswordError] = useState("");

  // Handle confirm password change
  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
    
    // Only show the error if confirmPassword is not empty and does not match password
    if (e.target.value && e.target.value !== password) {
      setPasswordError("Passwords do not match");
    } else {
      setPasswordError(""); // Clear error if passwords match or confirmPassword is empty
    }
  };
  
  return (
    <div className="flex-container">
      <div className="form-section">
        <div>
          <div>
            <h4 className="title">{"Change Password"}</h4>
            <p className="description">
              {
                "Enter the OTP sent to your email, along with your new password, to update your account password."
              }
            </p>
          </div>

          <div>
            <OTPInput
              numInputs={6}
              value={otp} // Bind the value of OTP input to the state
              onChange={handleChange} // Update state on change
              containerStyle={{
                display: "flex",
                alignItems: "center",
                gap: "10px", // Add space between the input boxes
                margin: "50px 0 0 0",
              }}
              inputStyle={{
                width: "35px",
                height: "35px",
                borderRadius: "5px",
                textAlign: "center",
                fontSize: "20px",
                border: "2px solid #d9d9d9",
              }}
              inputType="tel"
              renderSeparator={<span> </span>}
              renderInput={(props) => <input {...props} />}
            />

            {!verifySpin
              ? showResendOTP && (
                  <span
                    style={{
                      fontWeight: "600",
                      fontSize: "20px",
                      color: "black",
                    }}
                  >
                    Resend OTP in{" "}
                    <span
                      style={{
                        color: "red",
                      }}
                    >
                      {timerCount}s
                    </span>
                  </span>
                )
              : ""}

            {!verifySpin ? (
              timerCount === 0 && !showResendOTP ? (
                <button
                  type="default"
                  style={{
                    borderColor: "#1890ff",
                    borderRadius: "4px",
                    width: "auto",
                    display: "flex", // This ensures text and image are aligned horizontally
                    alignItems: "center", // Vertically centers the text and image
                    padding: "6px 12px", // Optional padding for spacing
                    margin: "20px 0 0 0",
                  }}
                  onClick={handleResendOTP}
                >
                  <img
                    src={require("../../assets/refresh.svg").default}
                    alt="refresh"
                    style={{
                      marginRight: "8px", // Optional: Adds space between the text and the image
                      width: "25px", // Optional: Sets the image size, you can adjust this as needed
                      height: "25px", // Optional: Sets the image size, you can adjust this as needed
                    }}
                  />
                  Resend OTP
                </button>
              ) : (
                ""
              )
            ) : (
              ""
            )}
          </div>
          <div className="form-container">
            <form className="login-form" onSubmit={handleSubmit}>
              <div className="input-group">
                <input
                  type={isPasswordVisible ? "text" : "password"} // Toggle input type
                  id="password"
                  placeholder=" "
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  autoComplete="current-password"
                />
                <label htmlFor="password">{"password"}</label>
                <span
                  className="eye-icon"
                  onClick={() => setIsPasswordVisible(!isPasswordVisible)}
                >
                  {isPasswordVisible ? (
                    <img
                      src={require("../../assets/eye.svg").default}
                      alt="Show password"
                    />
                  ) : (
                    <img
                      src={require("../../assets/hidden.svg").default}
                      alt="Hide password"
                    />
                  )}
                </span>
              </div>

              <div className="input-group">
                <input
                  type={isPasswordVisible ? "text" : "password"} // Toggle input type
                  id="password"
                  placeholder=" "
                  value={confirmPassword}
                  // onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                  autoComplete="current-password"
                  onChange={handleConfirmPasswordChange} // Update this to the new handler
                />
                <label htmlFor="password">{"Confirm password"}</label>
                <span
                  className="eye-icon"
                  onClick={() => setIsPasswordVisible(!isPasswordVisible)}
                >
                  {isPasswordVisible ? (
                    <img
                      src={require("../../assets/eye.svg").default}
                      alt="Show password"
                    />
                  ) : (
                    <img
                      src={require("../../assets/hidden.svg").default}
                      alt="Hide password"
                    />
                  )}
                </span>
              </div>
              {/* Display the error message if passwords do not match */}
              {passwordError && (
                <div style={{ color: "red", fontSize: "12px" }}>
                  {passwordError}
                </div>
              )}
              {!verifySpin
                ? showResendOTP && (
                    <div
                      className="input-group"
                      style={{
                        textAlign: "center", // Vertically centers the text and image
                        display: "flex", // Use flexbox to center the button horizontally
                        justifyContent: "center", // Center button horizontally
                      }}
                    >
                      <button
                        style={{
                          borderColor: "#1890ff",
                          borderRadius: "4px",
                          margin: "10px 0 0 0",
                          width: "100%",
                          display: "flex", // This ensures the button contents are aligned horizontally
                          justifyContent: "center", // Center the text horizontally
                          alignItems: "center", // Center the text vertically
                          textAlign: "center", // Ensure text is centered in the button
                        }}
                        onClick={handleSubmit}
                      >
                        {isLoading ? "verifying" : "verify"}
                      </button>
                    </div>
                  )
                : ""}

              <ToastMessage
                message={error || successMessage}
                type={error ? "error" : "success"}
              />
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ChangePassword;
